/**
 * Changes the body attribute
 * Uses requestAnimationFrame to avoid React passive effects warning
 */
const changeHTMLAttribute = (attribute: string, value: string): boolean => {
    if (typeof window !== 'undefined' && document.documentElement) {
        // Use requestAnimationFrame to defer DOM manipulation
        requestAnimationFrame(() => {
            if (document.documentElement) {
                document.documentElement.setAttribute(attribute, value);
            }
        });
    }
    return true;
};

export { changeHTMLAttribute };